function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module utils/config
 */
import { isPlainObject, isElement, cloneDeepWith } from 'lodash-es';
/**
 * Handles a configuration dictionary.
 */

var Config = /*#__PURE__*/function () {
  /**
   * Creates an instance of the {@link ~Config} class.
   *
   * @param {Object} [configurations] The initial configurations to be set. Usually, provided by the user.
   * @param {Object} [defaultConfigurations] The default configurations. Usually, provided by the system.
   */
  function Config(configurations, defaultConfigurations) {
    _classCallCheck(this, Config);

    /**
     * Store for the whole configuration.
     *
     * @private
     * @member {Object}
     */
    this._config = {}; // Set default configuration.

    if (defaultConfigurations) {
      // Clone the configuration to make sure that the properties will not be shared
      // between editors and make the watchdog feature work correctly.
      this.define(cloneConfig(defaultConfigurations));
    } // Set initial configuration.


    if (configurations) {
      this._setObjectToTarget(this._config, configurations);
    }
  }
  /**
   * Set configuration values.
   *
   * It accepts both a name/value pair or an object, which properties and values will be used to set
   * configurations.
   *
   * It also accepts setting a "deep configuration" by using dots in the name. For example, `'resize.width'` sets
   * the value for the `width` configuration in the `resize` subset.
   *
   *		config.set( 'width', 500 );
   *		config.set( 'toolbar.collapsed', true );
   *
   *		// Equivalent to:
   *		config.set( {
   *			width: 500
   *			toolbar: {
   *				collapsed: true
   *			}
   *		} );
   *
   * Passing an object as the value will amend the configuration, not replace it.
   *
   *		config.set( 'toolbar', {
   *			collapsed: true,
   *		} );
   *
   *		config.set( 'toolbar', {
   *			color: 'red',
   *		} );
   *
   *		config.get( 'toolbar.collapsed' ); // true
   *		config.get( 'toolbar.color' ); // 'red'
   *
   * @param {String|Object} name The configuration name or an object from which take properties as
   * configuration entries. Configuration names are case-sensitive.
   * @param {*} value The configuration value. Used if a name is passed.
   */


  _createClass(Config, [{
    key: "set",
    value: function set(name, value) {
      this._setToTarget(this._config, name, value);
    }
    /**
     * Does exactly the same as {@link #set} with one exception – passed configuration extends
     * existing one, but does not overwrite already defined values.
     *
     * This method is supposed to be called by plugin developers to setup plugin's configurations. It would be
     * rarely used for other needs.
     *
     * @param {String|Object} name The configuration name or an object from which take properties as
     * configuration entries. Configuration names are case-sensitive.
     * @param {*} value The configuration value. Used if a name is passed.
     */

  }, {
    key: "define",
    value: function define(name, value) {
      var isDefine = true;

      this._setToTarget(this._config, name, value, isDefine);
    }
    /**
     * Gets the value for a configuration entry.
     *
     *		config.get( 'name' );
     *
     * Deep configurations can be retrieved by separating each part with a dot.
     *
     *		config.get( 'toolbar.collapsed' );
     *
     * @param {String} name The configuration name. Configuration names are case-sensitive.
     * @returns {*} The configuration value or `undefined` if the configuration entry was not found.
     */

  }, {
    key: "get",
    value: function get(name) {
      return this._getFromSource(this._config, name);
    }
    /**
     * Iterates over all top level configuration names.
     *
     * @returns {Iterable.<String>}
     */

  }, {
    key: "names",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function names() {
      var _i, _Object$keys, name;

      return _regeneratorRuntime.wrap(function names$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _i = 0, _Object$keys = Object.keys(this._config);

            case 1:
              if (!(_i < _Object$keys.length)) {
                _context.next = 8;
                break;
              }

              name = _Object$keys[_i];
              _context.next = 5;
              return name;

            case 5:
              _i++;
              _context.next = 1;
              break;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, names, this);
    })
    /**
     * Saves passed configuration to the specified target (nested object).
     *
     * @private
     * @param {Object} target Nested config object.
     * @param {String|Object} name The configuration name or an object from which take properties as
     * configuration entries. Configuration names are case-sensitive.
     * @param {*} value The configuration value. Used if a name is passed.
     * @param {Boolean} [isDefine=false] Define if passed configuration should overwrite existing one.
     */

  }, {
    key: "_setToTarget",
    value: function _setToTarget(target, name, value) {
      var isDefine = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      // In case of an object, iterate through it and call `_setToTarget` again for each property.
      if (isPlainObject(name)) {
        this._setObjectToTarget(target, name, isDefine);

        return;
      } // The configuration name should be split into parts if it has dots. E.g. `resize.width` -> [`resize`, `width`].


      var parts = name.split('.'); // Take the name of the configuration out of the parts. E.g. `resize.width` -> `width`.

      name = parts.pop(); // Iterate over parts to check if currently stored configuration has proper structure.

      var _iterator = _createForOfIteratorHelper(parts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;

          // If there is no object for specified part then create one.
          if (!isPlainObject(target[part])) {
            target[part] = {};
          } // Nested object becomes a target.


          target = target[part];
        } // In case of value is an object.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (isPlainObject(value)) {
        // We take care of proper config structure.
        if (!isPlainObject(target[name])) {
          target[name] = {};
        }

        target = target[name]; // And iterate through this object calling `_setToTarget` again for each property.

        this._setObjectToTarget(target, value, isDefine);

        return;
      } // Do nothing if we are defining configuration for non empty name.


      if (isDefine && typeof target[name] != 'undefined') {
        return;
      }

      target[name] = value;
    }
    /**
     * Get specified configuration from specified source (nested object).
     *
     * @private
     * @param {Object} source level of nested object.
     * @param {String} name The configuration name. Configuration names are case-sensitive.
     * @returns {*} The configuration value or `undefined` if the configuration entry was not found.
     */

  }, {
    key: "_getFromSource",
    value: function _getFromSource(source, name) {
      // The configuration name should be split into parts if it has dots. E.g. `resize.width` -> [`resize`, `width`].
      var parts = name.split('.'); // Take the name of the configuration out of the parts. E.g. `resize.width` -> `width`.

      name = parts.pop(); // Iterate over parts to check if currently stored configuration has proper structure.

      var _iterator2 = _createForOfIteratorHelper(parts),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var part = _step2.value;

          if (!isPlainObject(source[part])) {
            source = null;
            break;
          } // Nested object becomes a source.


          source = source[part];
        } // Always returns undefined for non existing configuration.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return source ? cloneConfig(source[name]) : undefined;
    }
    /**
     * Iterates through passed object and calls {@link #_setToTarget} method with object key and value for each property.
     *
     * @private
     * @param {Object} target Nested config object.
     * @param {Object} configuration Configuration data set
     * @param {Boolean} [isDefine] Defines if passed configuration is default configuration or not.
     */

  }, {
    key: "_setObjectToTarget",
    value: function _setObjectToTarget(target, configuration, isDefine) {
      var _this = this;

      Object.keys(configuration).forEach(function (key) {
        _this._setToTarget(target, key, configuration[key], isDefine);
      });
    }
  }]);

  return Config;
}(); // Clones configuration object or value.
// @param {*} source Source configuration
// @returns {*} Cloned configuration value.


export { Config as default };

function cloneConfig(source) {
  return cloneDeepWith(source, leaveDOMReferences);
} // A customized function for cloneDeepWith.
// It will leave references to DOM Elements instead of cloning them.
//
// @param {*} value
// @returns {Element|undefined}


function leaveDOMReferences(value) {
  return isElement(value) ? value : undefined;
}